import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './SharedLink.module.css';

import {
  settingsApiSlice,
  useGetShareLinkNotificationQuery,
} from '../../../services/settings';

import {
  SHARED_LINK_GUIDE,
  SHARED_LINK_NOTIFICATION,
} from '../../../constants';

import Table from '../Table';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import {
  selectShareLinkList,
  selectShareLinkPage,
  selectShareLinkSortDir,
  shareLinkListChanged,
  shareLinkPageChanged,
} from '../../../features/settingsSlice';

export default function SharedLink() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();

  const page = useAppSelector(selectShareLinkPage);
  const sortDir = useAppSelector(selectShareLinkSortDir);
  const list = useAppSelector(selectShareLinkList);

  const { data, isLoading } = useGetShareLinkNotificationQuery({
    page: 0,
    sortDir,
  });
  const [getSharedLink] =
    settingsApiSlice.useLazyGetShareLinkNotificationQuery();

  const updateList = async () => {
    try {
      const res = await getSharedLink({
        page,
        sortDir,
      }).unwrap();
      dispatch(shareLinkListChanged(res));
    } catch (error) {
      console.error('Fail to get list', error);
    }
  };

  useEffect(() => {
    updateList();
  }, [page, sortDir]);

  useEffect(() => {
    dispatch(shareLinkListChanged([]));
    dispatch(shareLinkPageChanged(0));
  }, []);

  if (isLoading) return null;

  return (
    <>
      <h2>{SHARED_LINK_NOTIFICATION}</h2>
      <p
        className={cx('fs16', 'tac')}
        dangerouslySetInnerHTML={{ __html: SHARED_LINK_GUIDE }}
      ></p>

      <Table name="sharedLink" list={list} />
    </>
  );
}
